// extracted by mini-css-extract-plugin
export var cardTitle = "_hz-1";
export var commentBubble = "_hz-e";
export var commentForm = "_hz-a";
export var commentInput = "_hz-b";
export var commentLabel = "_hz-d";
export var commentPrompt = "_hz-9";
export var csatCard = "_hz-0";
export var feedbackSection = "_hz-7";
export var starDisabled = "_hz-6";
export var starEmpty = "_hz-5";
export var starFilled = "_hz-4";
export var starWrapper = "_hz-3";
export var starsContainer = "_hz-2";
export var submittedComment = "_hz-c";
export var thankYouText = "_hz-8";